import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { Status } from "../../models/status";
import { mockedWorkorderStatus } from "./status-api.mock-constants";
import { StatusApi } from "./status-api.models";

@Injectable()
export class MockStatusApiService extends StatusApi {
  constructor() {
    super();
  }

  public getPredefinedStatuses(): Observable<Status[]> {
    return of(mockedWorkorderStatus);
  }
}
